import { Text, TypographyPage } from 'ui';

export default {
  letters: {
    e: {
      text: 'Energized by the outside world and tend to prefer spending time socializing with others rather than alone',
    },
    s: {
      text: 'Tends to learn by doing, rather than thinking it through completely first',
    },
    f: {
      text: 'Make decisions based on personal values and principles, as opposed to hard logic and facts',
    },
    j: {
      text: 'Organized and prompt, doing things as they “ought to be,” instead of figuring things out as they go',
    },
  },
  persons: [
    {
      slug: 'grande',
      name: 'Ariana Grande',
    },
    {
      slug: 'james',
      name: 'LeBron James',
    },
    {
      slug: 'king',
      name: 'Larry King',
    },
  ],
  advantages: [
    'Generous',
    'Sensitive',
    'Very Loyal',
    'Networking skills',
  ],
  disadvantages: [
    'Inflexible',
    'Aversive to conflict',
    'Too selfless',
    'Lacks spontaneity',
  ],
  aboutUsCards: [
    {
      color: 'orange',
      title: 'ESFJs and friendships',
      text: 'The ESFJ personality type is often warm and compassionate, enabling them to create large and strong friendship groups.',
    },
    {
      color: 'red',
      title: 'ESFJs and work',
      text: 'The ESFJ personality type is extroverted, sensing, feeling, and judging. They work well with structure and prefer to work in a team environment.',
    },
    {
      color: 'mint',
      title: 'ESFJs and romance',
      text: 'The ESFJ tend to take each stage of the relationship seriously, from the early stages of dating through to marriage. They struggle with casual relationships, preferring to be in stable and supportive relationships.',
    },
  ],
  aboutTypeDescription: (
    <TypographyPage dense>
      <Text>
        The ESFJ personality type has extraverted, sensing, feeling, and judging
        personality traits. They tend to be very practical and organized, with a
        friendly and loyal nature. It is estimated that about 12% of the
        population are this personality type.{' '}
      </Text>
      <Text>
        The ESFJ personality type is known as the Consul or the Caregiver. This
        is due to their kind-hearted nature and their need to put others'
        feelings before their own. The consul tends to be a great leader and a
        very hard worker.{' '}
      </Text>
    </TypographyPage>
  ),
  aboutTypeTextContent: (
    <TypographyPage dense>
      <Text>
        The primary function of the ESFJ personality type is ‘extraverted
        feeling.’ This means that the ESFJ is not only comfortable with
        expressing their own emotions, but also can readily take an emotional
        reading of those around them.{' '}
      </Text>
      <Text>
        ESFJs tend to adjust their actions and words to make sure everyone feels
        happy, supported, and cared for. They’re often the people who will make
        a joke at their own expense just to make someone else feel more
        comfortable.{' '}
      </Text>
    </TypographyPage>
  ),
};
